import React from 'react';
import { SuspenseUntilInView, Loader } from '@udemy/react-reveal-components';
import styles from "./course-details-quick-view-box.module.css";
import { CourseDetailsQuickViewBox } from './course-details-quick-view-box.react-component';

/**
 * Props for the `CourseDetailsQuickViewBoxLazy` component. Accepts all the props of the
 * `CourseDetailsQuickViewBox` as well
 */

/**
 * "Lazy" wrapper around the `CourseDetailsQuickViewBox` that uses React Suspense to render a
 * `Loader` until the component is in the viewport
 */
export const CourseDetailsQuickViewBoxLazy = ({
  courseCard,
  showQuickViewBox = true,
  ...rest
}) => {
  if (!showQuickViewBox) {
    return courseCard;
  }
  return /*#__PURE__*/React.createElement(SuspenseUntilInView, {
    className: styles['full-height'],
    fallback: /*#__PURE__*/React.createElement(Loader, null)
  }, /*#__PURE__*/React.createElement(CourseDetailsQuickViewBox, Object.assign({
    courseCard: courseCard
  }, rest)));
};
//# sourceMappingURL=course-details-quick-view-box-lazy.react-component.js.map